try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import { Breadcrumbs } from '@design-system/breadcrumbs';
import { Container } from '@design-system/container';
import { ExtendableImage } from '@design-system/extendable-image';
import { HeadingBlock } from '@design-system/heading-block';
import { Section } from '@design-system/section';
import { ShareBlock } from '@design-system/share-block';
import classNames from 'classnames';
import { forwardRef } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const PageHeader = forwardRef((_a, ref) => {
    var { className, mode, imageElement, headingBlock, hiddenPageHeading, variant, breadcrumbs, showBreadcrumbs = true, showShareBlock = false, shareBlock } = _a, htmlProperties = __rest(_a, ["className", "mode", "imageElement", "headingBlock", "hiddenPageHeading", "variant", "breadcrumbs", "showBreadcrumbs", "showShareBlock", "shareBlock"]);
    return (jsxs(Section, Object.assign({ ref: ref, className: classNames('cds-page-header', {
            [`cds-page-header--${variant}`]: variant,
            'cds-page-header--no-media': !imageElement,
            'cds-page-header--no-headline': !(headingBlock === null || headingBlock === void 0 ? void 0 : headingBlock.headline),
        }, className), mode: "transparent", removeAllSpacing: true, element: "header" }, htmlProperties, { children: [jsx(Section, Object.assign({ mode: mode, className: "cds-page-header__background" }, { children: jsx(Container, Object.assign({ className: "cds-page-header__container", maxWidth: variant === 'standard' ? 'max-grid' : 'max-text' }, { children: jsxs("div", Object.assign({ className: "cds-page-header__text" }, { children: [hiddenPageHeading ? (jsx("h1", Object.assign({ className: "cds-sr-only" }, { children: hiddenPageHeading }))) : null, showBreadcrumbs && breadcrumbs ? (jsx(Breadcrumbs, Object.assign({}, breadcrumbs))) : null, headingBlock && (jsx(HeadingBlock, Object.assign({ className: "cds-page-header__heading", align: variant === 'standard' ? 'start' : 'center' }, headingBlock, { headlineTag: hiddenPageHeading ? 'h2' : 'h1' }))), showShareBlock && shareBlock ? (jsx(ShareBlock, Object.assign({ align: variant === 'standard' ? 'start' : 'center' }, shareBlock))) : null] })) })) })), imageElement && (jsx("div", Object.assign({ className: "cds-page-header__image" }, { children: jsx(ExtendableImage, Object.assign({ className: "cds-page-header__image-img" }, imageElement)) })))] })));
});

export { PageHeader };
